export default __webpack_public_path__ + "static/media/IMG_4981.437aba0b.png";